import axios from 'axios'

export default axios.create({
    baseURL: "https://www.palladiumtest.live/paladiumback/",
    headers:{'Content-Type':'application/json'}
})